// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__3aLJT","infoBtn":"quickbooks_infoBtn__2OQ3A","formBox":"quickbooks_formBox__IHKnx","formFooter":"quickbooks_formFooter__ZYqvx"};